import { Script } from 'gatsby'
import React from 'react'
function HotJarScript() {
    return (
        <Script
            id="hotjar-tracking"
            dangerouslySetInnerHTML={{
                __html: `(function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:5065407,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'<a href="https://static.hotjar.com/c/hotjar-" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://static.hotjar.com/c/hotjar-&source=gmail&ust=1721986495828000&usg=AOvVaw0wKe_SOXgw2Wb4hbhExh9T">https://static.hotjar.com/c/hotjar-</a>','.js?sv=');`
            }}
        />
    )
}

export default HotJarScript
